import { render, staticRenderFns } from "./MemberSelectedItem.vue?vue&type=template&id=12e60d53&scoped=true"
import script from "./MemberSelectedItem.vue?vue&type=script&lang=js"
export * from "./MemberSelectedItem.vue?vue&type=script&lang=js"
import style0 from "./MemberSelectedItem.vue?vue&type=style&index=0&id=12e60d53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e60d53",
  null
  
)

export default component.exports